import React from 'react';
import { X } from 'lucide-react';
import Button from '../ui/components/Button';
import TextField from '../ui/components/TextField';
import './AssortDrawer.css';

const AssortDrawer = ({ isOpen, onClose, order, pendingAction, formData, onFormChange, onConfirm, onRequestOperator }) => {
  if (!isOpen || !order) return null;

  const huidRequired = order.requestHUID === true;

  const stampQtyFilled = order.selectedVariants?.every(
    (variant) => Number(formData.stampCertificateQtyPerSet?.[variant.size]) > 0
  );
  const stampCostFilled = Number(formData.stampCertificateCost) > 0;
  const confirmLocked = huidRequired && (!stampQtyFilled || !stampCostFilled);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="assort-drawer-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true" aria-labelledby="assort-drawer-title">
      <div className="assort-drawer">
        <div className="drawer-header">
          <h3 id="assort-drawer-title">Stamp / Certificate Details</h3>
          <button className="close-btn" onClick={onClose} aria-label="Close drawer">
            <X size={20} />
          </button>
        </div>

        <div className="drawer-body">
          <div className="assort-order-header">
            <h4>{order.category} / {order.productName}</h4>
            <p>{order.specification} / {order.styleType}</p>
          </div>

          {order.selectedVariants?.length > 0 && (
            <div className="assort-variants-box">
              <div className="variants-table-header">
                <span>Size</span>
                <span>Qty</span>
                <span>Stamp/Certificate Qty Per Set</span>
              </div>
              <div className="variants-table-body">
                {order.selectedVariants.map((variant) => (
                  <div key={variant.size} className="variants-table-row">
                    <span className="variant-size">{variant.size}</span>
                    <span className="variant-qty">{variant.quantity}</span>
                    <div className="variant-stamp-input">
                      <TextField
                        label=""
                        type="number"
                        value={formData.stampCertificateQtyPerSet?.[variant.size] ?? ''}
                        onChange={(e) => onFormChange('stampCertificateQtyPerSet', {
                          ...formData.stampCertificateQtyPerSet,
                          [variant.size]: e.target.value,
                        })}
                        placeholder="0"
                        min="0"
                        inputClassName="assort-input compact"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="assort-popup-fields">
            <TextField
              label="Single Stamp/Certificate Cost"
              type="number"
              value={formData.stampCertificateCost}
              onChange={(e) => onFormChange('stampCertificateCost', e.target.value)}
              placeholder="Enter cost"
              min="0"
              step="0.01"
              inputClassName="assort-input"
            />
          </div>

          {confirmLocked && (
            <p className="assort-lock-hint">
              Enter Stamp/Certificate Qty Per Set for all sizes and Stamp/Certificate Cost to enable Confirm.
            </p>
          )}
        </div>

        <div className="drawer-footer">
          <Button
            variant="secondary"
            onClick={onRequestOperator}
            disabled={pendingAction !== null}
            className="operator-btn"
          >
            {pendingAction === 'requestOperator' ? 'Requesting...' : 'Request Operator'}
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={pendingAction !== null || confirmLocked}
            className="confirm-btn"
          >
            {pendingAction === 'assort' ? 'Confirming...' : 'Confirm'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AssortDrawer;
